import { PhoneOutlined, PlusSquareOutlined } from '@ant-design/icons'
import { AutoComplete, Button, Flex, Form, FormInstance, FormProps, Input, Modal, Radio, Select } from 'antd'
import { useForm } from 'antd/es/form/Form'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { getInfoCustomer, ICustomerDetail_V4 } from '../../../api/customer/customerApi'
import { IRelationship_V2, updateRelativeCustomer_V4 } from '../../../api/relatives/relativesApi'
import * as selectOptionsApi from '../../../api/selectOptions/selectOptionsApi'
import { ho_chieu, icon_delelte } from '../../../components/ExportImgFigma'
import useThrottle from '../../../hook/useThrottle'
import useToast from '../../../hook/useToast'
import { dataTypeDocument, genders } from '../../../services/data'
import { selectorInfoUser } from '../../../store/slices/infoUserSlice'
import { fommatSelectOption } from '../../../until'
import './AddRelative.scss'
import { InforSelectedCodeCustomer } from './AddRelativeAddCustomer'
import { selectorCategoryCarIds } from '../../../store/slices/categoryCarSlice'
import useLoading from '../../../hook/useLoading'
import useDebounce from '../../../hook/useDebounce'

interface Props {
  show: boolean
  infoRelative?: IRelationship_V2
  infoCustomer?: ICustomerDetail_V4;
  modalClose?: () => void
  onSuccess?: () => void
  onSubmitFormModal?: (iSsuccess: boolean, message?: string) => void
}

const UpdateRelative: React.FC<Props> = (props) => {
  const {
    show, infoRelative, infoCustomer,
    modalClose, onSuccess, onSubmitFormModal
  } = props
  const formRef: any = useRef(null)
  const [form] = useForm()
  const inputRef = useRef<FormInstance>(null);
  const pushToast = useToast();
  const pushLoading = useLoading();
  const { unitTemp } = useSelector(selectorInfoUser)

  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)


  const [inforSelectedCodeCustomer, setInforSelectedCodeCustomer] = useState<InforSelectedCodeCustomer>()

  const [sLCodeCustomer, setSLCodeCustomer] = useState<selectOptionsApi.ICodeCustomer[]>([])
  const [sLRelative, setSLRelative] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLProfession, setSLProfession] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLTypePhone, setSLTypePhone] = useState<selectOptionsApi.ISelectOption[]>([])

  const [phoneTypeTmp, setPhoneTypeTmp] = useState<{ [key: number]: number }>({})

  const [paginationCodeCustomer, setPaginationCodeCustomer] = useState({ current: 1, pageSize: 30, total: 0 });
  const isDisable = useMemo(() => {
    return inforSelectedCodeCustomer !== undefined;
  }, [inforSelectedCodeCustomer]);


  const gSListCodeCustomer = useDebounce(async (current: number = 1) => {
    pushLoading(true)
    const result = await selectOptionsApi.getListCodeCustomer(
      permittedCategoryCarIds,
      undefined, undefined, undefined, undefined, 30, current
    );
    if (result?.status) {
      // Append nếu current > 1
      setSLCodeCustomer(prev =>
        current === 1
          ? result.data                // load lần đầu
          : [...prev, ...result.data]  // append
      );

      setPaginationCodeCustomer(prev => ({
        ...prev,
        current,
        total: result.total || 0
      }));
    }
    pushLoading(false)
  }, 300)

  const gSListRelatives = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListRelatives();
    if (result?.status) {
      setSLRelative(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gSLProfession = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getCLProfession();
    if (result?.status) {
      setSLProfession(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }
  const gSLTypePhone = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListTypePhone();
    if (result?.status) {
      setSLTypePhone(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }
  const gInfoCustomer = async () => {
    pushLoading(true)
    form.resetFields()
    const result = await getInfoCustomer(Number(inforSelectedCodeCustomer?.id))
    if (result?.status) {
      const { userName, gender, phone, CCCD, profession, email, relativeId } = result.data

      const validEmail = email?.map(email => ({ email }));
      form.setFieldsValue({
        "personContactId": inforSelectedCodeCustomer?.value,
        "username": userName[0]?.username,
        "gender": gender,
        "phone": phone,
        "CCCD": CCCD,
        "professionId": profession?.id,
        "email": validEmail,
        "relativeId": infoRelative?.relativeId,
      });
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }
  const handleSelectCodeCustomer = (value: InforSelectedCodeCustomer) => {
    setInforSelectedCodeCustomer(value)
  }

  const onPopupScroll = (e: any) => {
    const target = e.target;

    const isBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - 20;

    if (!isBottom) return;

    const { current, total } = paginationCodeCustomer;
    const hasMore = sLCodeCustomer.length < total;

    if (!hasMore) return;

    gSListCodeCustomer(current + 1);
  };

  const handleResetAll = () => {
    form.resetFields()

    setInforSelectedCodeCustomer(undefined)
  }
  const submitForm = useThrottle(() => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  }, 2000);

  const confimSubmit: FormProps["onFinish"] = useThrottle(async (values: any) => {
    const {
      personContactId, username, gender, CCCD, professionId, relativeId, phone, email
    } = values;

    const userNameTmp = [{ username, isPrimary: 1 }]

    // const userNameTmp = username ? [{ username, isPrimary: 0 }] : []
    const validEmail = email.map((item: any) => item?.email).filter((email: any) => typeof email === "string" && email.trim() !== "");
    const result = await updateRelativeCustomer_V4(
      Number(infoRelative?.id), 0, userNameTmp, phone,
      undefined, CCCD, gender,
      undefined, undefined, professionId, undefined,
      validEmail, undefined, undefined, undefined,
      undefined, undefined, undefined,
      infoCustomer?.id, relativeId, undefined, undefined,
      undefined, undefined,
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }

  }, 2000)



  useEffect(() => {
    if (show) {
      setSLCodeCustomer([]);
      setPaginationCodeCustomer({ current: 1, pageSize: 30, total: 0 });
      gSListCodeCustomer(1);
      if (!sLRelative.length)
        gSListRelatives()
      if (!sLProfession.length)
        gSLProfession()
      if (!sLTypePhone.length)
        gSLTypePhone()
    } else {
      form.resetFields()
      setInforSelectedCodeCustomer(undefined)
    }
  }, [show])

  useEffect(() => {
    if (inforSelectedCodeCustomer?.id) {
      gInfoCustomer()
    }
  }, [inforSelectedCodeCustomer])

  useEffect(() => {
    if (show && infoRelative) {
      const {
        email, phone, username, CCCD, gender, code, professionId, relativeId
      } = infoRelative;

      if (inforSelectedCodeCustomer?.id) {
        setInforSelectedCodeCustomer(inforSelectedCodeCustomer)
      } else {

        const validEmail = email?.map((email: any) => ({ email }));
        form.setFieldsValue({
          "personContactId": code,
          "username": username,
          "gender": gender,
          "phone": phone,
          "CCCD": CCCD,
          "professionId": professionId,
          "email": validEmail,
          "relativeId": relativeId,
        });
      }
    }
  }, [infoRelative])

  return (
    // đổi với chỉnh sửa người liên hệ chỉ cho phép chỉnh sửa "mối quan hệ" còn lại disabled, như form thêm mới
    <Form
      form={form}
      ref={inputRef}
      className='rs-form add-relative-form'
      onFinish={confimSubmit}
    >
      <Modal
        open={show}
        title='Chỉnh sửa người liên hệ'
        className='rs-modal w-572 footer-content-end add-relative-modal'
        centered
        footer={
          <>
            <Button
              type='primary'
              className='rs-button rs-button--sm'
              onClick={handleResetAll}
            >Làm mới</Button>
            <Button
              type='primary'
              className='rs-button rs-button--sm'
              onClick={submitForm}
            >Lưu</Button>
          </>

        }
        onCancel={modalClose}
      >
        <div className="d-flex flex-column gap-2">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Mã định danh khách hàng :
          </p>
          <Form.Item
            layout='vertical'
            name="personContactId"
            rules={[{ required: true, message: 'Vui lòng nhập mã số thuế' }]}

          >
            <AutoComplete
              disabled
              // disabled={isDisable}
              onPopupScroll={onPopupScroll}
              placeholder="Mã định danh khách hàng"
              options={sLCodeCustomer.map((item) => ({
                value: item.code,         // Giá trị hiển thị trong ô tìm kiếm
                label: `${item.code} - ${item.username}`, // Gợi ý hiển thị dropdown
                id: item.id,              // Giá trị thực tế bạn muốn lấy khi chọn
              }))}
              filterOption={(inputValue, option) =>
                !!option?.value?.toLowerCase().includes(inputValue.toLowerCase())
              }
              onSelect={(value, option) => {
                handleSelectCodeCustomer(option)
              }}
            >
              <Input className="custom-input-css custom-page-css border " />
            </AutoComplete>
          </Form.Item>
        </div>
        <div className="d-flex flex-column gap-1 pt-2">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Họ và tên
            <div>
              <span className="text-F5222D">*</span>
              :
            </div>

          </p>
          <Form.Item
            layout='vertical'
            // label='Họ và tên'
            name='username'

            rules={[
              { required: true, message: "Vui lòng nhập Họ và tên" }
            ]}
          >
            <Input
              // disabled={isDisable}
              disabled
              placeholder='Họ và tên'
              className='custom-input-css custom-page-css border '
            />
          </Form.Item>
        </div>


        <Form.Item
          label=''
          name='gender'
          className='pt-2'
        >
          <Radio.Group
            className='rs-radio-group gender-group'
          >
            {
              genders.map((item: any) => (
                <Radio.Button
                  // disabled={isDisable}
                  disabled
                  key={item.value}
                  value={item.value}
                  className='rs-radio'
                >
                  <span className='inner-text'>{item.icon}{item.label}</span>
                </Radio.Button>
              ))
            }
          </Radio.Group>
        </Form.Item>

        <div className="d-flex flex-column gap-1 pt-2">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Số điện thoại
            <div>
              <span className="text-F5222D">*</span>
              :
            </div>
          </p>
          <Form.List
            name="phone"
            initialValue={[{ phone: "", categoryPhoneId: null }]}
          >
            {
              (fields, { add, remove }) => (
                <Flex vertical className="gap-10px">
                  {
                    fields.map((field) => (
                      <div key={field.key} className="d-flex gap-1">
                        {/* shouldUpdate để đọc trạng thái categoryPhoneId của từng dòng */}
                        <Form.Item noStyle shouldUpdate>
                          {
                            ({ getFieldValue }) => {
                              const selected = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                              return (
                                <Form.Item
                                  className="w-full"
                                  name={[field.name, "phone"]}
                                  rules={[
                                    { required: true, message: "Vui lòng nhập số điện thoại" },
                                    () => ({
                                      validator(_, value) {
                                        if (!value) return Promise.resolve();

                                        const phoneType = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                                        if (!phoneType) return Promise.resolve();

                                        const isHome = phoneType === 1;
                                        const isCompany = phoneType === 2;

                                        if (isHome && !/^0\d{9}$/.test(value)) {
                                          return Promise.reject(
                                            new Error(
                                              "Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)"
                                            )
                                          );
                                        }

                                        if (isCompany && !/^0\d{10,11}$/.test(value)) {
                                          return Promise.reject(
                                            new Error(
                                              "Số điện thoại không hợp lệ (11-12 số, bắt đầu bằng 0)"
                                            )
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                >
                                  <Input
                                    prefix={<PhoneOutlined />}
                                    placeholder="Số điện thoại"
                                    className="custom-input-css custom-page-css border "
                                    type="tel"
                                    // disabled={!selected} // Chỉ nhập khi đã chọn loại điện thoại
                                    disabled
                                  />
                                </Form.Item>
                              );
                            }}
                        </Form.Item>
                        <Form.Item
                          name={[field.name, "categoryPhoneId"]}
                          rules={[{ required: true, message: "Vui lòng chọn loại điện thoại" }]}
                        >
                          <Select
                            // disabled={isDisable}
                            disabled
                            options={sLTypePhone}
                            placeholder="Loại điện thoại"
                            className="custom-page-css border rounded overflow-hidden w-150-px"

                            onChange={(val) => {
                              // Nếu bỏ chọn => xóa luôn số điện thoại
                              if (val == null) {
                                const curr = (form?.getFieldValue?.("phone") ?? []).slice();
                                if (curr[field.name]) curr[field.name].phone = "";
                                form?.setFieldsValue?.({ phone: curr });
                              }
                            }}
                          />
                        </Form.Item>
                        <img
                          hidden={fields.length <= 1}
                          src={icon_delelte}
                          alt=""
                          className={`${true ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                          // className={`${isDisable ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                          onClick={() => remove(field.name)} // dùng field.name an toàn hơn index
                        />
                      </div>
                    ))
                  }
                  <div
                    className={`${true ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"}`}
                    // className={`${isDisable ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"}`}
                    onClick={() => add({ phone: "", categoryPhoneId: null })}
                  >
                    <PlusSquareOutlined className="text-sm" />
                    <span className="text-sm">Thêm số điện thoại mới</span>
                  </div>
                </Flex>
              )
            }
          </Form.List>
        </div>
        <div className='pt-2'>
          <div className="d-flex gap-1 mb-1">
            {/* Field Số CCCD/Hộ Chiếu */}
            <Form.Item
              className="w-full"
              name={["CCCD", 0, "name"]} // Thêm index 0
              initialValue=""
              rules={[
                { required: true, message: "Vui lòng nhập giấy tờ" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const typeDoc = getFieldValue(["CCCD", 0, "identityType"]);

                    if (!typeDoc && typeDoc !== 0) {
                      return Promise.reject(new Error("Vui lòng chọn loại giấy tờ trước"));
                    }

                    if (!value || value.trim() === "") {
                      return Promise.reject(new Error("Vui lòng nhập số giấy tờ"));
                    }

                    if (typeDoc === 0 && !/^\d{12}$/.test(value)) {
                      return Promise.reject(new Error("CCCD phải gồm đúng 12 chữ số"));
                    }

                    const passport = value?.toUpperCase().trim();

                    if (typeDoc === 1 && !/^[A-Z0-9]{6,9}$/.test(passport)) {
                      return Promise.reject(
                        new Error(
                          "Số hộ chiếu không hợp lệ (6–9 ký tự chữ hoặc số)"
                        )
                      );
                    }


                    // Đảm bảo isPrimary luôn = 1
                    const currentCCCD = getFieldValue("CCCD") || [];
                    if (currentCCCD[0] && currentCCCD[0].isPrimary !== 1) {
                      form.setFieldsValue({
                        CCCD: [{ ...currentCCCD[0], isPrimary: 1 }]
                      });
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input
                prefix={<img src={ho_chieu} />}
                placeholder="Nhập số CCCD/Hộ chiếu"
                disabled
                className="custom-input-css custom-page-css border "
              />
            </Form.Item>

            {/* Field Loại Giấy Tờ */}
            <Form.Item
              name={["CCCD", 0, "identityType"]} // Thêm index 0
              initialValue={null}
              rules={[{ required: true, message: "Vui lòng chọn loại" }]}
            >
              <Select
                options={dataTypeDocument}
                disabled
                placeholder="Loại"
                className="custom-page-css border rounded overflow-hidden w-200-px"
                onChange={(val) => {
                  // Luôn đảm bảo isPrimary = 1 khi thay đổi loại
                  const currentCCCD = form.getFieldValue("CCCD") || [];
                  const currentItem = currentCCCD[0] || {};

                  form.setFieldsValue({
                    CCCD: [
                      {
                        ...currentItem,
                        identityType: val,
                        name: "",
                        isPrimary: 1
                      }
                    ]
                  });
                }}
              />
            </Form.Item>
          </div>
          {/* Hidden field với giá trị mặc định */}
          <Form.Item name={["CCCD", 0, "isPrimary"]} initialValue={1} hidden>
            <Input type="hidden" />
          </Form.Item>
        </div>
        <Form.Item
          layout='vertical'
          label='Nghề nghiệp :'
          name='professionId'
          className='pt-2'
        >
          <Select
            // disabled={isDisable}
            disabled
            placeholder='Nghề nghiệp'
            className='custom-page-css border rounded overflow-hidden'

            options={sLProfession}
          />
        </Form.Item>
        <div className="d-flex flex-column gap-1 pt-2">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Email :
          </p>
          <Form.List
            name="email"
            initialValue={[{}]}
          >
            {(fields, { add, remove }) => (
              <div className='d-flex flex-column gap-1'>
                {fields.map((field, i) => (
                  <div key={field.key} className="d-flex gap-2">

                    <Form.Item
                      name={[field.name, 'email']}
                      fieldKey={[i, "email"]}
                      className="m-none-form-item text-explan w-full"
                      rules={[
                        {
                          type: 'email',
                          message: 'Email không hợp lệ',
                          // validateTrigger: 'onBlur',
                        },
                      ]}
                    >
                      <Input
                        // disabled={isDisable}
                        disabled
                        placeholder="Email"
                        className="custom-input-css custom-page-css border "
                      />
                    </Form.Item>
                    <img
                      hidden={fields.length <= 1}
                      src={icon_delelte}
                      alt=""
                      // className={` ${isDisable ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                      className={` ${true ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                      onClick={() => remove(i)}
                    />
                  </div>
                ))}
                <div
                  // className={` ${isDisable ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"} `}
                  className={` ${true ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"} `}
                  onClick={() => add({})}

                >
                  <PlusSquareOutlined className="text-sm" />
                  <span className="text-sm">Thêm mail mới</span>
                </div>
              </div>
            )}
          </Form.List>
        </div>



        {/* đổi với chỉnh sửa người liên hệ chỉ cho phép chỉnh sửa "mối quan hệ" còn lại disabled, như form thêm mới */}
        <Form.Item
          layout='vertical'
          label='Mối quan hệ :'
          name='relativeId'
          rules={[
            { required: false, message: "Vui lòng chọn mối quan hệ" }
          ]}
        >
          <Select
            placeholder='Mối quan hệ'
            className='custom-page-css border rounded overflow-hidden'

            options={sLRelative}
          />
        </Form.Item>






        {/* <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
          Địa chỉ
        </p>
        <Form.Item
          layout='vertical'
        // label='Địa chỉ'
        >
          <Flex vertical className='gap-4px'>
            <Flex className='gap-10px'>
              <Form.Item
                label=''
                name='thanhPho'
                // rules={[
                //   { required: true, message: "Vui lòng chọn tỉnh/ thành phố" }
                // ]}
                className='w-full'
              >
                <Select
                  placeholder='Chọn tỉnh/thành phố'
                  className='rs-select'
                   
                  options={sLProvice}
                  value={provice}
                  onChange={setProvice}
                />
              </Form.Item>

              <Form.Item
                label=''
                name='quan'
                // rules={[
                //   { required: true, message: "Vui lòng chọn quận/ huyện" }
                // ]}
                className='w-full'
              >
                <Select
                  placeholder='Chọn quận/huyện'
                  className='rs-select'
                   
                  options={sLDistrict}
                />
              </Form.Item>
            </Flex>

            <Form.Item
              label=''
              name='diaChi'
            // rules={[
            //   { required: true, message: "Vui lòng nhập địa chỉ" }
            // ]}
            >
              <Input
                placeholder='Địa chỉ'
                className='rs-input rs-input--32'
              />
            </Form.Item>
          </Flex>
        </Form.Item> */}

      </Modal >
    </Form>
  )
}

export default UpdateRelative
